export enum Scope {
  Organization = "organization",
  Workspace = "workspace",
  Connection = "connection",
}

// Permissions will be included in the organization and workspace API response.
// The naming convention is `<scope>__<permission>`, for example `organization__can_edit_name`.
export enum Permission {
  // organization
  OrgChangeName = "organization__can_edit_name",
  OrgChangeLogo = "organization__can_edit_logo",
  OrgUpdateRole = "organization__can_edit_role",
  OrgAddMembers = "organization__can_add_members",
  OrgRemoveMembers = "organization__can_remove_members",
  OrgAddConnection = "organization__can_create_connection",
  OrgViewConnection = "organization__can_view_connection",
  OrgViewConnectionDetails = "organization__can_view_connection_details",
  OrgUpdateConnection = "organization__can_edit_connection",
  OrgViewMetrics = "organization__can_view_organization_metrics",

  // workspace
  WsCreate = "workspace__can_create",
  WsChangeName = "workspace__can_edit_name",
  WsUpdateRole = "workspace__can_edit_role",
  WsAddMembers = "workspace__can_add_members",
  WsRemoveMembers = "workspace__can_remove_members",
  WsAddAdmins = "workspace__can_add_admins",
  WsRemoveAdmins = "workspace__can_remove_admins",
  WsUpdateResources = "workspace__can_edit_resources", // add or remove contextSource, Agent, etc.
  WsDelete = "workspace__can_delete",

  // connection
  ConnCreate = "connection__can_create_connection",
  ConnEdit = "connection__can_edit_connection",
  ConnView = "connection__can_view_connection",
  ConnViewDetails = "connection__can_view_connection_details",
}
